var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1777_4340)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.91406,
    y: 3.81812,
    width: 60.6864,
    height: 60.6864,
    rx: 9.48224,
    fill: "#6F52EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4436 45.4213C16.3342 45.4213 13.8135 42.9006 13.8135 39.7913C13.8135 36.6819 16.3342 34.1613 19.4436 34.1613C22.553 34.1613 25.0736 36.6819 25.0736 39.7913C25.0736 42.9006 22.553 45.4213 19.4436 45.4213Z",
    stroke: "white",
    strokeWidth: 3.55585
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.7415,
    y1: 39.569,
    x2: 13.7415,
    y2: 26.3828,
    stroke: "white",
    strokeWidth: 3.40769,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0642 45.4213C52.1737 45.4213 54.6943 42.9006 54.6943 39.7913C54.6943 36.6819 52.1737 34.1613 49.0642 34.1613C45.9548 34.1613 43.4342 36.6819 43.4342 39.7913C43.4342 42.9006 45.9548 45.4213 49.0642 45.4213Z",
    stroke: "white",
    strokeWidth: 3.55585
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.70384,
    y1: -1.70384,
    x2: 14.8901,
    y2: -1.70384,
    transform: "matrix(0 -1 -1 0 53.0625 41.2729)",
    stroke: "white",
    strokeWidth: 3.40769,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.2667,
    cy: 25.8643,
    r: 3.55585,
    transform: "rotate(90 34.2667 25.8643)",
    stroke: "white",
    strokeWidth: 2.37056
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2578 34.6058L34.2578 44.977",
    stroke: "white",
    strokeWidth: 4.44481,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1777_4340",
    x: 0.841335,
    y: 0.745388,
    width: 69.9057,
    height: 69.9045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.53636,
    dy: 1.53636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30455
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_4340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_4340",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAppIcon);
export default __webpack_public_path__ + "static/media/userAppIcon.2c857a8ef912c188b2bf5281f8da5765.svg";
export { ForwardRef as ReactComponent };